import {
    ChangeDetectionStrategy,
    Component,
    inject,
    input,
} from '@angular/core';
import { ButtonSize, IconButtonComponent } from '@interacta-shared/ui';
import { HistoryRoutingService } from '@interacta-shared/util-common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'interacta-back',
    templateUrl: './back.component.html',
    imports: [IconButtonComponent, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BackComponent {
    readonly size = input<ButtonSize>('regular');

    private historyRoutingService = inject(HistoryRoutingService);

    back(): void {
        this.historyRoutingService.back();
    }
}
